/**
 * Makes a number negative or returns null if null
 *
 * Ever wanted to make a number negative and format it as currency but show N/A if it's null?
 * Just do {{ $ctrl.someNumber | toNegative | nfcurrency }}
 *
 * toNegative will preserve the null, and nfcurrency will show the N/A
 */
export default function ToNegativeFilter() {
  return (theNumber) => {
    if (theNumber == null) {
      return null;
    }

    return 0 - theNumber;
  };
}
